module.exports = __webpack_public_path__ + "img/pull-down.06dc2ecc.svg";